import { render, staticRenderFns } from "./DWebpImage.vue?vue&type=template&id=5cd5120c&"
import script from "./DWebpImage.vue?vue&type=script&lang=js&"
export * from "./DWebpImage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports